import axios from 'axios'

export const installedBaseAPI = function (baseURL) {
  this.host = baseURL ? baseURL : 'https://' + window.location.hostname
}

installedBaseAPI.prototype.getURL = function (path) {
  return `${this.host}${path}`
}

installedBaseAPI.prototype.getInstalledBaseList = function () {
  const url = this.getURL('/ib/api/v1/installed-base/list')
  return axios(url, {withCredentials: true})
}

installedBaseAPI.prototype.getProjectList = function () {
  const url = this.getURL('/ib/api/v1/project/list')
  return axios(url, {withCredentials: true})
}

installedBaseAPI.prototype.getMachinesByProject = function (project_id) {
  const url = this.getURL('/ib/api/v1/installed-base/machines/project/' + project_id)
  return axios.get(url, {withCredentials: true})
}

installedBaseAPI.prototype.getProject = function (project_id) {
  const url = this.getURL('/ib/api/v1/project/' + encodeURIComponent(project_id))
  return axios.get(url, {withCredentials: true})
}

installedBaseAPI.prototype.saveProject = function (project) {
  const url = this.getURL('/ib/api/v1/project')
  return axios.put(url, project, {withCredentials: true})
}

installedBaseAPI.prototype.saveMachines = function (machines) {
  const url = this.getURL('/ib/api/v1/installed-base/many')
  return axios.put(url, machines, {withCredentials: true})
  // return fetch(url, {method: 'PUT', credentials: 'include', body: JSON.stringify(project)})
  // return fetch(url, {method: 'PUT', credentials: 'include', body: JSON.stringify(machines)})
  //   .then(res => res.json())
}

installedBaseAPI.prototype.getCities = function () {
  const url = this.getURL('/ib/api/v1/cities')
  return axios(url, {withCredentials: true})
}

installedBaseAPI.prototype.contactsByCustomer = function (customerNumber) {
  const customerNumberEncoded = encodeURIComponent(customerNumber)
  const url = this.getURL(`/ib/api/v1/customers/${customerNumberEncoded}/crm-contacts`)
  return axios(url, {withCredentials: true})
}

installedBaseAPI.prototype.getMachineStatus = function () {
  const url = this.getURL('/ib/api/v1/settings/machine-status')
  return axios.get(url, {withCredentials: true})
}

installedBaseAPI.prototype.getSalesOfficeLocation = function () {
  const url = this.getURL('/ib/api/v1/sales-office/location')
  return axios.get(url, {withCredentials: true})
}

installedBaseAPI.prototype.setProjectToSalesOfficeLocation = function (project) {
  const url = this.getURL('/ib/api/v1/project/location-to-sales-office')
  return axios.post(url, project, {withCredentials: true})
}
